export default {
  name: 'TsCard',
  functional: true,
  render(h, context) {
    return (
      <div
        class="widget widget-rounded"
        {...{ class: context.data.staticClass }}
      >
        {context.children}
      </div>
    )
  }
}
